import { translate } from '@/domains/core/localization/translate';
export const translations = translate({
  "relevance": "Sort by : relevance",
  "price.asc": "Sort by : price ascending",
  "price.desc": "Sort by : price descending",
  "rating.desc": "Sort by : rating descending"
});